import { MasterFilter } from "@/types/master-filter";

export const masterTableKeys = {
  all: ['masterTable'] as const,
  byTypeFilter: (filter: MasterFilter) => ['masterTable', filter] as const,
};
